<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <h3>HUAYIN METAPHOR</h3>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 公司简介 -->
      <section id="gsjj">
        <div class="banner-bottom">
          <div class="col-md-1 banner-bottom-left"></div>
          <div class="col-md-4 banner-bottom-left1">
            <div class="banner-bottom-left1-grid">
              <div class="globe">
                <span></span>
              </div>
              <h3><span>We will turn </span>INTRODUCTION</h3>
              <div class="progress progress1">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
              <p>
                Huayin is an foreign-invested company which is specialized in
                pre-fabricated steel structures’ design, manufacturing and
                erection. The company was originally established in 1994 by a
                group of professional engineers and business people with long
                working experience in pre-fabricated steel construction industry
                of the USA and Australia background. With modern production
                equipment and fabrication technology, Huayin has a annual
                capacity of 50 thousand tons of heavy steel structure and a
                total of 30 thousand tons of cold rolled corrugated sheets
                production for roof and wall system. The main international
                Quality Management and related certificates that we have been
                awarded include the following AISC ; LGA ;AWS ;ISO-9001
                (SGS);Factory Production Control (FPC) Approval;ISO
                14001;OHSAS18001. In additional, Huayin also owns First Grade
                Certificate in Steel Structure Engineering design and Second
                Grade certificate for Steel structure engineering construction
                work.
                <span class="textShow"
                  >Huayin attaches great importance to the technical support and
                  after-sales service of each project, and has set up a number
                  of branches in the national sub-districts to ensure that
                  customers can get Huayin's high-quality services conveniently
                  and timely.Most of the famous enterprises are customers of
                  Huayin, it is also exported to United States,
                  Japan, Europe, Australia, Korea, Thailand, Haiti and even
                  South Africa, Angola and other African regions.</span
                >
              </p>
            </div>
          </div>
          <div class="col-md-7 banner-bottom-left2">
            <div class="grid">
              <figure class="effect-lexi effect-lexi1">
                <img src="@/components/img/gyhy/3.jpg" alt="" />
                <figcaption class="lexifig">
                  <!-- <h4>华胤集团--<span>企业视觉形象</span></h4> -->
                  <p>
                    huanyin attaches great importance to the technical support
                    and after sales service of each project
                  </p>
                </figcaption>
              </figure>
            </div>
            <h3>
              Huayin have successfully accomplished more than 3000 projects,
              with total building area reaching 10 million square-meters. These
              achievements have led to honorable recognition in receiving “Jin
              Gang Awards” and “Excellent Projects Awards” etc held by the
              Chinese Authority.
            </h3>
          </div>
          <div class="clearfix"></div>
        </div>
      </section>

      <!-- 公司文化 -->
      <section id="gswh">
        <div class="banner-bottom1 container">
          <div class="row">
            <div class="col-md-6 banner-bottom-left2 banner-bottom1-left2">
              <div class="grid">
                <figure class="effect-lexi">
                  <img src="@/components/img/gyhy/2.jpg" alt="" />
                  <figcaption>
                    <!-- <h4>华胤集团--<span>企业名称文化</span></h4> -->
                    <p>huayin has its own unique yin culture。</p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="col-md-4 banner-bottom-lft1">
              <h3>01 .</h3>
              <h4>PURPOSE</h4>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
              <p>
                Hua Yin Group is dedicated to becoming a pacesetter in the global steel structure industry. We 
                achieve this by relentlessly pursuing technological innovation, offering unparalleled customer 
                service, and delivering professional design acumen. Our commitment to providing our clients 
                with top-tier products is unwavering, and it is through this dedication that we aim to establish a 
                world-class steel structure brand.<br>
                Our goal is to transcend industry standards, ensuring that each project we engage in stands as a beacon of our expertise and our unwavering dedication to the highest levels of excellence. 
              </p>
            </div>
            <div class="col-md-2 banner-bottom-left"></div>
            <div class="clearfix"></div>
          </div>
          <div class="row">
            <div class="col-md-2 banner-bottom-left"></div>
            <div class="col-md-4 banner-bottom-lft1">
              <h3>02 .</h3>
              <h4 class="with">VISION</h4>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
              <p>
                We aspire to be a globally recognized brand, renowned for offering our customers services that 
are not only sustainable but also synonymous with excellence. We envision ourselves as a catalyst 
for innovation in the steel construction industry, a beacon leading the way towards revolution, 
and a driving force for positive societal impact. <br>
Our mission is to harness the power of our 
collective efforts to foster a living environment that is not just more robust and green but also 
deeply connected. We are committed to shaping a future where every structure we touch 
contributes to a better world for generations to come."
              </p>
            </div>
            <div class="col-md-6 banner-bottom-left2 banner-bottom1-left2">
              <div class="grid">
                <figure class="effect-lexi effect-lexi1">
                  <img src="@/components/img/gyhy/4.jpg" alt="" />
                  <figcaption class="lexifig">
                    <!-- <h4>华胤集团--<span>企业商标文化</span></h4> -->
                    <p>huayin trademark has special significance</p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </section>

      <!-- 公司新闻 -->
      <section id="hyxw">
        <div class="container" style="margin-top: 40px;">
          <div class="row">
            <div
              class="col-md-2 banner-bottom-lft1 visible-xs"
              style="
                background: #fff;
                text-align: center;
                box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
              "
            >
              <h3 class="mobh">04 .<br />Huayin News</h3>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
            </div>
            <div
              class="col-md-2 banner-bottom-lft1 hidden-xs"
              style="
                background: #fff;
                text-align: center;
                box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
              "
            >
              <h3 class="mobh">04 .<br />Huayin<br />News</h3>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
            </div>
            <div class="col-md-10">
              <div class="action--site-equipment controller--site">
                <div class="equipmentList">
                  <div class="main">
                    <div class="equipmentListItem">
                      <div
                        class="ListItem ListItems fadeInUp wow animated"
                        data-wow-delay="0.1s"
                        v-for="(item, index) in newsenList"
                        :key="index"
                        @click="listClick(index)"
                        :class="{ active: index == showList }"
                      >
                        <div class="Item">
                          <h5>{{ item.newsTitle }}</h5>
                        </div>
                        <div
                          class="Itemtext"
                          :style="{
                            display: index == showList ? 'block' : 'none',
                          }"
                        >
                          <div class="box">
                            <div class="left double-border" >
                              <div class="col-md-4" v-if="item.newsImage!=null">
                                <img :src="item.newsImage" alt="" style="width: 100%;padding: 10px 0;">
                              </div>
                              <div class="col-md-4" v-else>
                                <img src="@/components/img/logoEN.png" alt="" style="width: 100%;padding: 10px 0;">
                              </div>
                              <div class="col-md-8" style="display: flex;align-items: center;justify-content: center;">
                                <p v-html="item.newsContent" style="padding: 15px 0;"></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 公司荣誉 -->
      <section id="gsry">
        <div class="container">
          <div class="row">
            <div
              class="col-md-2 banner-bottom-lft1 visible-xs"
              style="
                background: #fff;
                text-align: center;
                box-shadow: rgba(0, 0, 0, 0.15) -1.6px 4px 3.2px 2.4px;
              "
            >
              <h3 class="mobh">05 .<br />Huayin Honor</h3>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
            </div>
            <div class="col-md-10">
              <div style="text-align: center">
                <h2>Qualification Certificate</h2>
              </div>
              <carousel-3d
                :controlsVisible="true"
                :width="cWidth1"
                :height="cHeight1"
                :display="5"
                :space="cSpace1"
              >
                <slide
                  v-lazy-container="{ selector: 'img' }"
                  :index="index"
                  v-for="(item, index) in zzzsList"
                  :key="index"
                >
                  <img :data-src="item.image" class="slideImg" alt="" />
                  <p class="slideP">{{ item.text }}</p>
                </slide>
              </carousel-3d>

              <div style="text-align: center">
                <h2>Certificate Honor</h2>
              </div>
              <carousel-3d
                :controlsVisible="true"
                :width="cWidth3"
                :height="cHeight3"
                :display="5"
                :space="cSpace3"
              >
                <slide
                  v-lazy-container="{ selector: 'img' }"
                  :index="index"
                  v-for="(item, index) in ryzsList"
                  :key="index"
                >
                  <img :data-src="item.image" class="slideImg" alt="" />
                  <p class="slideP">{{ item.text }}</p>
                </slide>
              </carousel-3d>
              <div style="text-align: center">
                <h2>Patent Certificate</h2>
              </div>
              <carousel-3d
                :controlsVisible="true"
                :width="cWidth3"
                :height="cHeight3"
                :display="5"
                :space="cSpace3"
              >
                <slide
                  v-lazy-container="{ selector: 'img' }"
                  :index="index"
                  v-for="(item, index) in zlzsList"
                  :key="index"
                >
                  <img :data-src="item.image" class="slideImg" alt="" />
                  <p class="slideP">{{ item.text }}</p>
                </slide>
              </carousel-3d>
            </div>
            <div
              class="col-md-2 banner-bottom-lft1 hidden-xs"
              style="
                background: #fff;
                text-align: center;
                box-shadow: rgba(0, 0, 0, 0.15) -1.6px 4px 3.2px 2.4px;
              "
            >
              <h3 class="mobh">05 .<br />Huayin<br />Honor</h3>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 小滚轮 -->
      <div id="ss_menu">
        <div>
          <i><a @click="forId('gsjj')">Introduction</a></i>
        </div>
        <div>
          <i><a @click="forId('gswh')">Culture</a></i>
        </div>
        <div>
          <i><a @click="forId('hyxw')">News</a></i>
        </div>
        <div>
          <i><a @click="forId('gsry')">Honor</a></i>
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      showList: -1,
      zzzsList: [
        {
          image: require('@/components/img/gyhy/zzzsen1.png'),
          text: 'CQM Environmental Management System Certification',
        },
        {
          image: require('@/components/img/gyhy/zzzsen2.png'),
          text: 'CQM Occupational Health and Safety Management System Certification',
        },
        {
          image: require('@/components/img/gyhy/zzzs3.png'),
          text: 'IQNET Certification',
        },
        {
          image: require('@/components/img/gyhy/zzzs4.png'),
          text: 'IQNET Certification',
        },
        {
          image: require('@/components/img/gyhy/zzzs5.png'),
          text: 'United States Steel Construction Association Quality AISC Certification',
        },
        {
          image: require('@/components/img/gyhy/zzzs6.png'),
          text: 'CWB CSA Certification',
        },
        {
          image: require('@/components/img/gyhy/zzzs7.png'),
          text: 'United States AWS certification',
        },
        {
          image: require('@/components/img/gyhy/zzzs8.png'),
          text: 'United States AWS certification',
        },
        {
          image: require('@/components/img/gyhy/zzzs9.png'),
          text: 'China Steel Structure Manufacturing Enterprise Qualification Certificate',
        },
        {
          image: require('@/components/img/gyhy/zzzs10.png'),
          text: 'EU EN1090 certification',
        },
        {
          image: require('@/components/img/gyhy/zzzs11.png'),
          text: 'EU EN ISO3834 certification',
        },
        {
          image: require('@/components/img/gyhy/zzzs13.png'),
          text: 'Switzerland SGS-ISO9001 quality system certification',
        },
      ],
      ryzsList: [
        {
          image: require('@/components/img/gyhy/ryzs1.jpg'),
          text: 'China steel structure ten influential brands',
        },
        {
          image: require('@/components/img/gyhy/ryzs2.jpg'),
          text: 'Heavy machinery shanghai industrial co ltd plant',
        },
        {
          image: require('@/components/img/gyhy/ryzs3.jpg'),
          text: 'China cargo air logistics center',
        },
        {
          image: require('@/components/img/gyhy/ryzs4.jpg'),
          text: 'China cargo airlines pudong logistics center',
        },
        {
          image: require('@/components/img/gyhy/ryzs5.jpg'),
          text: 'China cargo airlines pudong logistics center',
        },
        {
          image: require('@/components/img/gyhy/ryzs6.jpg'),
          text: 'kong award tongrentang',
        },
        {
          image: require('@/components/img/gyhy/ryzs7.jpg'),
          text: 'shanghai secco',
        },
        {
          image: require('@/components/img/gyhy/ryzs8.jpg'),
          text: 'mingchen plastic technology co ltd plant',
        },
        {
          image: require('@/components/img/gyhy/ryzs9.jpg'),
          text: 'wison science park project',
        },
        {
          image: require('@/components/img/gyhy/ryzs10.jpg'),
          text: 'chuangzi clothing co ltd factory',
        },
        {
          image: require('@/components/img/gyhy/ryzs11.jpg'),
          text: 'certificate of merchantable goods',
        },
        {
          image: require('@/components/img/gyhy/ryzs12.jpg'),
          text: 'minjiang cup award certificate',
        },
      ],
      zlzsList: [
        {
          image: require('@/components/img/gyhy/zlzs1.jpg'),
          text: 'new v type pull rod',
        },
        {
          image: require('@/components/img/gyhy/zlzs2.jpg'),
          text: 'new windproof buckle plate',
        },
        {
          image: require('@/components/img/gyhy/zlzs3.jpg'),
          text: 'roof ventilation device',
        },
        {
          image: require('@/components/img/gyhy/zlzs4.jpg'),
          text: 'roofing metal plate mounting device',
        },
        {
          image: require('@/components/img/gyhy/zlzs5.jpg'),
          text: 'roof steel plate wind resistant structure',
        },
        {
          image: require('@/components/img/gyhy/zlzs6.jpg'),
          text: 'hand door opener',
        },
        {
          image: require('@/components/img/gyhy/zlzs7.jpg'),
          text: 'embossed embossed steel bearing floor slab',
        },
        {
          image: require('@/components/img/gyhy/zlzs8.jpg'),
          text: 'symmetrical double stiffened steel bearing floor',
        },
        {
          image: require('@/components/img/gyhy/zlzs9.jpg'),
          text: 'windproof device for rolling shutter door',
        },
        {
          image: require('@/components/img/gyhy/zlzs10.jpg'),
          text: 'steel sandwich roof',
        },
      ],
    }
  },
  mounted() {
    // 获取高度
    window.onresize = () => {
      this.changeHeight()
    }

    this.$store.dispatch('newsenList')
  },
  computed: {
    ...mapState({
      newsenList: (state) => {
        return state.news.newsenList
      },
    }),
  },
  methods: {
    // 调用全局方法，滚动指定id
    forId(tId) {
      console.log(tId);
      this.$store.dispatch('toID', tId);
    },

    listClick(index) {
    
      if (this.showList == index) {
        this.showList = -1
      } else {
        this.showList = index
      }
    },

    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth1 = 500
        this.cHeight1 = 700
        this.cSpace1 = 400
        this.cWidth2 = 800
        this.cHeight2 = 550
        this.cSpace2 = 400
        this.cWidth3 = 800
        this.cHeight3 = 550
        this.cSpace3 = 350
      } else if (document.body.clientWidth >= 768) {
        this.cWidth1 = 500
        this.cHeight1 = 600
        this.cSpace1 = 320
        this.cWidth2 = 600
        this.cHeight2 = 400
        this.cSpace2 = 380
        this.cWidth3 = 600
        this.cHeight3 = 400
        this.cSpace3 = 250
      } else if (document.body.clientWidth < 768) {
        this.cWidth1 = 400
        this.cHeight1 = 500
        this.cSpace1 = 320
        this.cWidth2 = 600
        this.cHeight2 = 400
        this.cSpace2 = 380
        this.cWidth3 = 600
        this.cHeight3 = 400
        this.cSpace3 = 250
      }
    },
  },
  updated() {
    if (this.scrollToElement) {
      this.scrollToElement()
      this.scrollToElement = null
    }
  },
  created() {
    this.changeHeight()
  },
}
</script>

<style scoped>
@import url('./css/global.css');
/* 荣誉图片注释设置 */
.slideImg {
  width: 100%;
  height: 100%;
  margin-bottom: -30px;
  padding-bottom: 30px;
}
.slideP {
  text-align: center;
  color: #000;
  font-size: 13px;
  line-height: 30px;
}
#gsjj {
  margin-top: -83px;
  padding-top: 83px;
}
#gswh {
  margin-top: -83px;
  padding-top: 83px;
}
#zzjg,
#hyxw,
#gsry {
  margin-top: -83px;
  padding-top: 83px;
}
/* {
	margin-top: -100px;
}
{
	margin-top: -100px;
} */
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/gyhy/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  margin-bottom: 5px;
}

/*-- banner-info --*/
.banner-info {
  padding: 14em 0 0;
  text-align: center;
}
.banner-info h3 {
  width: 60%;
  font-size: 4em;
  color: #fff;
  margin: 0 auto;
  line-height: 1.5em;
  padding: 0.5em;
  background: rgba(0, 0, 0, 0.6);
  font-family: 微软雅黑;
}

@media screen and (max-width: 768px) {
  .mobh {
    font-size: 30px !important;
  }
  .banner-bottom-left1-grid p {
    margin: 1em 0 !important;
    font-size: 13px !important;
    line-height: 1.5em !important;
  }
}
/*-- banner-bottom --*/
.banner-bottom-left p {
  color: #fff;
  font-size: 14px;
  margin: 0;
  line-height: 1.8em;
}
.banner-bottom-left1 {
  padding: 8em 5em 5em;
  background: #a56c41;
}
.banner-bottom-left2 {
  padding: 0;
}
.globe span {
  background: url(@/components/img/gyhy/img-sp.png) no-repeat 22px -81px;
  display: block;
  width: 128px;
  height: 128px;
  border: 1px solid #3f647d;
  border-radius: 100%;
}
.banner-bottom-left1-grid h3 {
  margin: 1.5em 0 0;
  color: #fff;
  font-size: 3.5em;
  text-transform: capitalize;
}
.banner-bottom-left1-grid h3 span {
  font-size: 0.3em;
  display: block;
  margin-bottom: 1em;
}
.progress1 {
  height: 2px;
  margin-bottom: 0;
  border-radius: 0;
  margin: 1.5em 0 0;
}
.progress-bar1 {
  background: #eb6f63;
}
.banner-bottom-left1-grid p {
  margin: 2em 0 0 0;
  color: #fff;
  font-size: calc(100vw* 16 / 1644);
  line-height: 1.8em;
}
.banner-bottom-left2 h3 {
  padding: 1.5em 3em 0;
  font-size: calc(100vw* 22 / 1644);
  color: #212121;
  margin: 0;
  line-height: 1.6em;
  position: relative;
  font-family: 'Open Sans', sans-serif;
}

/*-- effect --*/
.grid {
  position: relative;
  clear: both;
  list-style: none;
  text-align: center;
}

/* Common style */
.grid figure {
  position: relative;
  float: none;
  overflow: hidden;
  margin: 0;
  min-width: 273px;
  max-width: 100%;
  max-height: auto;
  width: 100%;
  height: auto;
  background: #3085a3;
  text-align: center;
}

.grid figure img {
  position: relative;
  display: block;
  min-height: 100%;
  max-width: 100%;
  opacity: 0.8;
}

.grid figure figcaption {
  padding: 2em;
  color: #fff;
  text-transform: uppercase;
  font-size: 1.25em;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.grid figure figcaption::before,
.grid figure figcaption::after {
  pointer-events: none;
}

.grid figure figcaption,
.grid figure figcaption > a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
/***** Lexi *****/
/*---------------*/

figure.effect-lexi {
  background: -webkit-linear-gradient(-45deg, #000 0%, #fff 100%);
  background: linear-gradient(-45deg, #000 0%, #fff 100%);
}

figure.effect-lexi img {
  margin: -10px 0 0 -10px;
  max-width: none;
  width: -webkit-calc(100% + 10px);
  width: calc(100% + 10px);
  opacity: 0.9;
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
  -webkit-transform: translate3d(10px, 10px, 0);
  transform: translate3d(10px, 10px, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

figure.effect-lexi figcaption::before,
figure.effect-lexi p {
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
}

figure.effect-lexi figcaption::before {
  position: absolute;
  left: -40px;
  bottom: -60px;
  width: 330px;
  height: 330px;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 900px rgba(255, 255, 255, 0.2);
  content: '';
  opacity: 0;
  -webkit-transform: scale3d(0.5, 0.5, 1);
  transform: scale3d(0.5, 0.5, 1);
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
}
figure.effect-lexi figcaption.lexifig::before {
  right: -40px;
  left: auto;
}

figure.effect-lexi:hover img {
  opacity: 0.6;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

figure.effect-lexi h4 {
  font-size: 1.5em;
  text-transform: capitalize;
  text-align: left;
  padding: 0.5em 1em;
  background: rgba(200, 0, 0, 0.4);
  width: 66%;
  text-align: left;
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(5px, 5px, 0);
  transform: translate3d(5px, 5px, 0);
}

figure.effect-lexi h4 span {
  color: #000;
}

figure.effect-lexi p {
  position: absolute;
  left: 0;
  bottom: 2%;
  padding: 0 0 1.5em 1em;
  width: 250px;
  text-align: left;
  opacity: 0;
  -webkit-transform: translate3d(20px, 20px, 0);
  transform: translate3d(20px, 20px, 0);
  font-size: 0.8em;
  line-height: 1.8em;
}

figure.effect-lexi1 p {
  right: 0;
  padding: 0 1em 1.5em 0 !important;
  left: auto;
}

figure.effect-lexi:hover figcaption::before {
  opacity: 1;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

figure.effect-lexi:hover h4,
figure.effect-lexi:hover p {
  opacity: 1;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
/*-- //effect --*/
/*-- //banner-bottom --*/
/*-- banner-bottom1 --*/
.banner-bottom-lft1 h3 {
  font-size: 5em;
  color: #3f5a6d;
  margin: 0;
}
.banner-bottom-left1,
.banner-bottom-lft1 {
  padding: 2.17em 3em 3em;
  background: #a56c41;
}
.banner-bottom-lft1 h4 {
  font-size: 3em;
  color: #fff;
  text-align: right;
  margin: 1em 0 0em;
  line-height: 1.5em;
  font-family: 'Open Sans', sans-serif;
}
.progress2 {
  margin: 1em 0 0;
}
.banner-bottom-lft1 p {
  margin: 2.5em 0 0;
  color: #fff;
  font-size: 16px;
  line-height: 1.8em;
}
h4.with {
  text-align: left;
}

/*-----start-responsive-design------*/
@media (max-width: 1680px) {
  .banner-bottom-left1,
  .banner-bottom-lft1 {
    padding: 1.5em 2em;
  }
  .progress2 {
    margin: 1.6em 0 0;
  }
  .banner-bottom-left2 h3 {
    padding: 1.5em 3em 0;
  }
}
@media (max-width: 1600px) {
  .banner-bottom-left1,
  .banner-bottom-lft1 {
    padding: 1.7em 2em 2em;
  }
  .progress2 {
    margin: 1em 0 0;
  }
  .banner-bottom-left2 h3 {
    padding: 1.5em 3em 0;
  }
}
@media (max-width: 1440px) {
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -90px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 3.5em;
  }
  .banner-bottom-lft1 {
    padding: 1em 2em 2.04em;
  }
  figure.effect-lexi h4 {
    width: 75%;
  }
}
@media (max-width: 1366px) {
  .banner-info {
    padding: 10em 0 0;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -50px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 3.4em;
  }
  .banner-bottom-left2 h3 {
    font-size: 1.6em;
  }
  .banner-bottom-left1 {
    padding: 1.7em 2em 2em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 1.7em;
  }
  .banner-bottom-lft1 h3 {
    font-size: 4em;
  }
  figure.effect-lexi h4 {
    width: 79%;
  }
}
@media (max-width: 1280px) {
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -90px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-lft1 h4 {
    font-size: 1.5em;
  }
  .banner-bottom-lft1 {
    padding: 1em 2em 1.3em;
  }
  figure.effect-lexi h4 {
    font-size: 1.3em;
  }
  .banner-bottom-left1-grid h3 {
    margin: 1em 0 0;
  }
  .banner-bottom-lft1 p {
    margin: 2.4em 0 0;
  }
}
@media (max-width: 1080px) {
  .banner-info h3 {
    font-size: 2em;
  }
  .banner-info {
    padding: 8em 0 0;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -125px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }

  .banner-bottom-left1-grid h3 {
    font-size: 2.5em;
  }
  .banner-bottom-left2 h3 {
    padding: 2.5em 4em 0;
    font-size: 1.5em;
  }
  figure.effect-lexi figcaption::before {
    width: 260px;
    height: 260px;
  }
  figure.effect-lexi p {
    bottom: -3%;
    width: 155px;
    font-size: 13px;
  }
  .banner-bottom-left1 {
    padding: 1.7em 2em 2em;
  }
  .banner-bottom-left1-grid p {
    margin: 2em 0 3em;
  }
  .m1 a {
    padding: 6px 175px 10px !important;
  }
  .banner-bottom-lft1 h4 {
    font-size: 1.3em;
  }
  .banner-bottom-lft1 h3 {
    font-size: 3em;
  }
  .banner-bottom-lft1 p {
    margin: 1em 0 0;
  }
  .banner-bottom-left {
    width: 6%;
  }
  .banner-bottom-left2 {
    width: 68.33%;
  }
  .banner-bottom1-left2 {
    width: 58.33% !important;
  }
  .banner-bottom-lft1 {
    padding: 1em 2em 4.4em;
    width: 35.66%;
  }
  .banner-bottom-slider-left h3 span {
    font-size: 1.5em;
  }
  figure.effect-lexi h4 {
    width: 80%;
  }
  .banner-bottom-slider-right {
    padding: 0;
  }
  .banner-bottom-slider-right1 ul li a {
    font-size: 14px;
  }
  .banner-bottom-slider-right1 p span {
    font-size: 1.14em;
  }

  .blog-title {
    padding: 1.5em 0.5em;
  }
  .blod-meta li::before {
    margin: 0 1px;
  }
  .blod-meta {
    padding: 0 0 10px;
    margin: 1em 0 0em;
  }
  .blog-title p {
    font-size: 12px;
  }
  .panel-title {
    font-size: 1.1em;
    background: url(@/components/img/gyhy/1.png) no-repeat 242px -2px;
  }
  .panel-title1 {
    background: url(@/components/img/gyhy/1.png) no-repeat 0 1px !important;
  }
  .panel-default:nth-child(2) {
    margin: 1em 0 !important;
  }
  .comments ul li {
    margin-right: 1em;
  }
  .single-left h3 {
    font-size: 1.2em;
  }
  .single-left h3:before {
    height: 100%;
  }
  .single-left3-grid p {
    font-size: 14px;
  }
  .leave-a-comment input[type='text'],
  .leave-a-comment input[type='email'],
  .leave-a-comment textarea {
    width: 32.04%;
  }
  .leave-a-comment h3 {
    margin: 0 0 1em;
  }

  .mail input[type='text'],
  .mail input[type='email'],
  .mail textarea {
    width: 49.3%;
  }
  .mail input[type='submit'] {
    margin-left: 29.8em;
  }
}
@media (max-width: 1024px) {
  .banner-bottom-left1 {
    padding: 1.7em 2em 2em;
  }
  .banner-bottom-lft1 {
    padding: 1em 2em 1.5em;
  }
}
@media (max-width: 991px) {
  .p-mask h4 {
    font-size: 1em;
    line-height: 1.5em;
  }
  .p-mask p {
    line-height: 1.5em;
    font-size: 13px;
  }

  .banner-info h3 {
    width: 70%;
  }

  .banner {
    background: url(@/components/img/gyhy/1.jpg) -163px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .social-icons {
    padding: 5em 0 0;
  }
  .banner-bottom-left1 {
    float: none;
    width: 70%;
    margin: 0 auto;
    padding: 3em 3em 4em;
  }
  .banner-bottom-left2 {
    float: none;
    margin: 0 auto;
    width: 70%;
  }
  .banner-bottom-left2 h3 {
    padding: 2em 3em 2em;
  }

  .banner-bottom1-left2 {
    width: 70% !important;
  }
  .banner-bottom-lft1 {
    padding: 1em 3em 3em;
    float: none;
    width: 70%;
    margin: 0 auto 2em;
  }
  .banner-bottom-lft1:nth-child(6) {
    margin: 0 auto;
  }
  .banner-bottom-slider-left {
    margin: 0 0 2em;
  }
  .banner-bottom-slider-right1 p span {
    font-size: 1.5em;
  }

  .testimonials-grid {
    float: left;
    width: 33.33%;
  }
  .history-right {
    margin: 2em 0 0;
  }
  figure.blog-figure img {
    width: 100%;
  }
  .panel-group .panel {
    text-align: left;
  }
  .panel-title1 {
    background: url(@/components/img/gyhy/1.png) no-repeat 0 -3px !important;
  }

  .search1 input[type='submit'] {
    margin: 1em 0 0;
  }
  .categories {
    margin: 3em 0;
  }
  .categories-mid ul li:nth-child(6) {
    margin-bottom: 0;
  }
  .single-left {
    margin: 3em 0 0;
  }
  .single-left1-grid:nth-child(2) {
    margin: 2em 0;
  }
  .single-left2 {
    margin: 0 0 2em;
  }
  .single-left3-grid {
    float: left;
    width: 50%;
  }
  .leave-a-comment input[type='text'],
  .leave-a-comment input[type='email'],
  .leave-a-comment textarea {
    width: 31.65%;
  }
  .mail input[type='submit'] {
    margin-left: 34.6em;
  }
  .contact-right1-pos {
    left: 3.5%;
    width: 55%;
    min-height: 90%;
  }
}
@media (max-width: 800px) {
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -217px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1,
  .banner-bottom-left2,
  .banner-bottom-lft1 {
    width: 90% !important;
  }
}
@media (max-width: 768px) {
  .testimonials-grid2 {
    padding: 1em;
  }
  .testimonials-grid1 h4 {
    font-size: 1.1em;
  }
  .single-left1 h5 {
    margin: 0 0 1em;
  }
}
@media (max-width: 667px) {
  .banner-info h3 {
    font-size: 1.8em;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -250px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
}
@media (max-width: 640px) {
  .p-mask h4 {
    font-size: 1.5em;
    line-height: 1.8em;
  }

  .progress1 {
    height: 2px !important;
    margin-bottom: 0 !important;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 2em;
  }
  .m1 a {
    padding: 0px 110px 10px !important;
  }
  .banner-bottom-left2 h3 {
    padding: 2em 2em 2em;
  }

  figure.effect-lexi h4 {
    width: 85%;
  }

  p.dummy-text {
    padding-left: 15em;
  }
  .testimonials-grid1 h4 {
    font-size: 1.4em;
  }
  .testimonials-grid {
    padding-left: 0;
  }

  .single-left1-grid p span {
    display: inline;
    margin: 0;
  }
  .single-left2 {
    margin: 0;
  }
  .comments-admin h4,
  .leave-a-comment h3 {
    font-size: 1.7em;
  }
  .leave-a-comment input[type='text'],
  .leave-a-comment input[type='email'],
  .leave-a-comment textarea {
    width: 31.29%;
  }
  .leave-a-comment input[type='submit'] {
    font-size: 14px;
    width: 35%;
  }
  .mail {
    margin: 2em 0 0;
  }
  .mail input[type='text'],
  .mail input[type='email'],
  .mail textarea {
    width: 49.26%;
  }
  .mail input[type='submit'] {
    margin-left: 28em;
  }
  .contact-right1-pos {
    left: 3.5%;
    width: 69%;
    min-height: 92%;
    top: 4%;
  }
}
@media (max-width: 600px) {
  .banner-info h3 {
    font-size: 1.5em;
  }
}
@media (max-width: 568px) {
  .banner-info {
    padding: 5em 0 0;
  }
}
@media (max-width: 480px) {
  .banner-info {
    padding: 6em 0 0;
  }
  .banner-info h3 {
    font-size: 1.3em;
    width: 80%;
  }

  .social-icons {
    padding: 4em 0 0;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -267px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1,
  .banner-bottom-left2,
  .banner-bottom-lft1 {
    width: 95% !important;
  }
  figure.effect-lexi h4 {
    font-size: 1em;
  }
  .grid figure figcaption {
    padding: 1em;
  }
  .banner-bottom-left2 h3 {
    font-size: 13px;
  }

  .banner-bottom-lft1 h4 {
    font-size: 1.2em;
  }
  .banner-bottom-lft1 {
    padding: 1em 2em 2em;
  }
  .banner-bottom-lft1 {
    margin: 0 auto 0.8em;
  }

  .comments ul li {
    margin-bottom: 1em;
  }
  .single-left {
    padding-left: 1em;
    padding-right: 0;
  }
  .leave-a-comment input[type='text'],
  .leave-a-comment input[type='email'],
  .leave-a-comment textarea {
    width: 100%;
  }
  .leave-a-comment input[type='email'] {
    margin: 1em 0;
  }
  .leave-a-comment textarea {
    min-height: 150px;
    margin: 1em 0 0.8em;
  }
  .leave-a-comment input[type='submit'] {
    width: 100%;
    padding: 8px 0;
  }
  .contact-left1 iframe {
    min-height: 200px;
  }
  .contact-left2 h4 {
    margin: 1em 0 1em;
  }
  .mail input[type='text'],
  .mail input[type='email'],
  .mail textarea {
    width: 100%;
  }
  .mail input[type='email'] {
    margin: 0.5em 0 0;
  }
  .mail input[type='submit'] {
    margin: 0 0 2em;
  }
  .mail input[type='submit'] {
    width: 100%;
    padding: 8px 0;
  }
  .contact-right p {
    margin: 1em 0 0 1em;
  }
  .contact-right1-pos {
    left: 5.5%;
    width: 89%;
    min-height: 91%;
    top: 4.5%;
  }
}
@media (max-width: 414px) {
  .banner-info h3 {
    font-size: 2em;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
    height: 190px !important;
  }
  .banner-bottom-left1 {
    padding: 1.7em 2em 2em;
  }
  .globe span {
    background: url(@/components/img/gyhy/img-sp.png) no-repeat 16px -55px;
    background-size: 400%;
    width: 90px;
    height: 90px;
  }
  figure.effect-lexi p {
    width: 145px;
    font-size: 10px;
  }
  figure.effect-lexi figcaption::before {
    width: 210px;
    height: 210px;
  }
  .banner-bottom-slider-left h3 span {
    font-size: 1.2em;
  }
  .banner-bottom-slider-left {
    margin: 0 0 1.5em;
  }
  .testimonials-grid {
    width: 100%;
  }
  .single-right {
    padding: 0;
  }
  .single-left3-grid {
    float: none;
    width: 100%;
  }
  .single-left3-grid:nth-child(1) {
    margin-bottom: 1em;
  }
  .admin {
    margin: 2em 0;
    padding: 1em;
  }
  .comments-admin-grids {
    margin: 2em 0 0;
  }
  .comments-admin h4,
  .leave-a-comment h3 {
    font-size: 1.5em;
  }
  .leave-a-comment {
    margin: 3em 0 0;
  }
  .contact-left,
  .contact-right {
    padding: 0;
  }
}
@media (max-width: 384px) {
  .banner-info h3 {
    width: 90%;
  }
  .social-icons {
    padding: 3em 0 0;
  }
}

@media (max-width: 768px) {
  .banner-info h3 {
    font-size: 1.5em;
    width: 100%;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -252px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-info {
    padding: 4em 0 0;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 1.5em;
  }
  .progress1 {
    margin: 1em 0 0;
  }
  .banner-bottom-left1-grid p {
    margin: 1em 0 2em;
    font-size: 13px;
  }
  .banner-bottom-left1 {
    padding: 1em 1em 2em;
  }
  .m1 a {
    padding: 0px 80px 10px !important;
  }
  .grid figure figcaption {
    padding: 0em 1em;
  }
  .banner-bottom-left2 h3 {
    font-size: 1em;
    line-height: 1.5em;
  }
  .banner-bottom-lft1 {
    padding: 1em 1em 2em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 1.5em;
  }
  .banner-bottom-lft1 p {
    font-size: 13px;
  }

  figure.effect-lexi h4 {
    width: 91%;
  }
  .equipmentList .equipmentListItem .ListItem .Item h5 {
    font-size: 16px;
  }
}
/* 小滚轮 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px !important;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #a56c41;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 10px;
  text-align: center;
  background: #a56c41;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #ed9048;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -160px;
}

#ss_menu div:nth-child(2) {
  top: -80px;
  left: -138.56406px;
}

#ss_menu div:nth-child(3) {
  top: -138.56406px;
  left: -80px;
}

#ss_menu div:nth-child(4) {
  top: -160px;
  left: 0px;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
@media screen and (max-width: 1999px) {
  .textShow {
    display: none;
  }
}
@media screen and (min-width: 2000px) {
  .banner-bottom-left1-grid p {
    font-size: 20px;
  }
  .textShow {
    display: block;
  }
  .grid {
    max-width: 1500px;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 5em;
  }
  .banner-bottom-lft1 h3 {
    font-size: 6em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 4em;
  }
  .banner-bottom-lft1 p {
    font-size: 20px;
  }
  .equipmentList .equipmentListItem .ListItem .Item h5 {
    font-size: 25px;
  }
  .equipmentList .equipmentListItem .ListItem .Itemtext .box .left p {
    font-size: 20px;
    line-height: 30px;
  }
  .slideP {
    font-size: 20px;
  }

}
.double-border {
  width: 100% !important;
  position: relative;
  border: 2px solid #000;
  padding: 5px;
}
/* 外边框样式 */
.double-border::before {
  content: "";
    position: absolute;
    width: 40px;
    height: 40px;
    transition: .3s ease-in-out;
    top: -8px;
    left: -8px;
    border-top: 2px solid #000;
    border-left: 2px solid #000;
}
.double-border::after {
    content: "";
    position: absolute;
    width: 40px;
    height: 40px;
    transition: .3s ease-in-out;
    right: -8px;
    bottom: -8px;
    border-bottom: 2px solid #000;
    border-right: 2px solid #000;
  
}
</style>
